export enum Periodo {
    inicial = 'INICIAL',
    anual = 'ANUAL',
    posExercicio = 'POS_EXERCICIO',
    final = 'FINAL',
    mudancaSubstancial = 'MUDANCA_SUBSTANCIAL',
    trianual = 'TRIANUAL',
    adHoc = 'AD_HOC'
}
